import { useEffect, useState } from 'react';


// TODO: 
// 1) add delete buttons for each image
// 2) add new file(s) to existing file list(to imageS state)
// 3) do available for not only images, but also other kinds of file(eg:/ pdf, doc, etc)
//    previews available only for images? or for others too(eg:/ pdf)?
// + 4) Re-write to field component
// 5) add file type: image, doc, pdf, etc
// 6) implement FileReader


const UploadFile = (props) => {
  const [files, setFiles] = useState([]);
  const [imgURLs, setImageURLs] = useState([]);

  const { multiple, input, values, accept } = props;

  // console.log('props', multiple, input, values, accept);

  // useEffect(() => {
  //   if (files.length < 1) {
  //     return;
  //   }
  //   const newImageURLs = [];
  //   for (let file of files) {
  //     newImageURLs.push(URL.createObjectURL(file));
  //   }
  //   setImageURLs(newImageURLs);        
  // }, [files]);

  const isImage = ["image/*", ".png, .jpg, .jpeg"].includes(accept);
  // console.log('isImage', isImage);

  const onImageChange = (event) => {
    if (!event.target.files || event.target.files.length < 1) {
      return;
    }
    // TODO: Check mime type what should it accept

    const eventTargetFiles = [...event.target.files];

    // Serialize File: Convert File object to JSON
    const newFiles = eventTargetFiles.map(file => {
      const replacer = [];
      for (const key in file) {
        replacer.push(key);
      }
      return JSON.stringify(file, replacer);
    });

    // Set images in Component's local STATE
    setFiles(newFiles);

    if (isImage) {
      // Create Image URLs
      const newImageURLs = [];
      for (let image of eventTargetFiles) {
        // console.log('onChange 5', image);
        newImageURLs.push(URL.createObjectURL(image));
      }
      // Set Image URLs in Component's local STATE
      setImageURLs(newImageURLs);
    }

    console.log()

    // Set serialized File object(JSON) in REDUX STORE
    // Should we store serialized File objects(newFiles) OR Image URLs(newImageURLs)?
    input.onChange(newFiles);
  }

  return (
    <div>
      <input
        type="file"
        multiple={multiple}
        value=""
        accept={accept}
        onChange={(event) => { onImageChange(event) }}
      />
      <div>
        {isImage
          ? imgURLs.map(imgSrc => <img key={imgSrc} src={imgSrc} />)
          : files.map(file => <div key={file}><label>{JSON.parse(file).name}</label></div>)
        }
      </div>
    </div>
  )
}

export default UploadFile;